import { createAuthClient } from "better-auth/react";
import { env } from "@/env";
import { emailOTPClient, magicLinkClient } from "better-auth/client/plugins";
import { stripeClient } from "@better-auth/stripe/client";

export const authClient = createAuthClient({
  baseURL: env.NEXT_PUBLIC_BASE_URL,
  plugins: [
    emailOTPClient(),
    magicLinkClient(),
    stripeClient({
      subscription: true,
    }),
  ],
});

export const { signIn, signOut, signUp, useSession } = authClient;

export const defaultSignOut = () => {
  void signOut({
    fetchOptions: {
      onSuccess: () => {
        // `redirect()` throws NEXT_REDIRECT in client callbacks.
        // Use a browser navigation instead.
        if (typeof window !== "undefined") {
          window.location.href = "/";
        }
      },
    },
  });
};
